// extracted by extract-css-chunks-webpack-plugin
module.exports = {"disconnected":"disconnected___2Q0FV","icon":"icon___2G4pD"};